import { processComponentOption, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_731ea706";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_731ea706" };
/** script content **/
require("./divider.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex731ea706%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Fdivider%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_731ea706"],
    ctorType: "component",
    outputPath: "components/index731ea706/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
